import type { Locale, LocalePort } from '../domain/locale'

const makeSetLocaleUseCase = (port: LocalePort) => (locale: Locale) => {
	port.set(locale)
}

export { makeSetLocaleUseCase }
